import { CicDisclosureType } from 'constants/cicReason';

export const CIC_FIELD_REASONS_MODAL_HEADER = 'Reasons for change of circumstance';

export const CIC_FIELD_REASONS_DESCRIPTION =
  'These changes trigger a revised disclosure. Pick a reason and add a comment for each field to finish saving.';

export const REASON_LABEL = 'Reason';

export const REASON_PLACEHOLDER = 'Select a reason';

export const COMMENT_LABEL = 'Comment';

export const COMMENT_PLACEHOLDER =
  'Explain what changed and why (available to documents as a dynamic field)';

export const REASON_REQUIRED_MESSAGE = 'Reason is required';

export const COMMENT_REQUIRED_MESSAGE = 'Comment is required';

export const NO_ACTIVE_REASONS_MESSAGE =
  'No active loan-term CIC reasons are set up for this company. Ask an admin to add one under System → CIC Reasons, then save again.';

export const LOAD_REASONS_ERROR_MESSAGE =
  "Couldn't load the CIC reasons. Cancel and save again to retry.";

export const COPY_FIRST_ROW_LABEL = 'Copy row 1 reason & comment to all rows';

export const RECALCULATED_FIELDS_PREFIX = 'Also recalculated by this save, no reason needed:';

export const RECALCULATED_FIELDS_SUFFIX =
  'These changed as a result of the edits above, not by hand.';

export const SENDING_UNCHANGED_MESSAGE =
  "Saving won't change how the CIC is sent: the revised disclosure goes out automatically, the same as today. Fee changes are explained on the Fees page and aren't listed here.";

export const FEE_REASON_DISCLOSURE_MESSAGE =
  "A fee's reason prints on the CIC cover letter and can trigger a revised disclosure. A fee applied as a cure gets no reason, so if every change is a cure, a revised disclosure may not go out.";

export const CIC_FEE_REASONS_DESCRIPTION =
  'These fees changed and are above their disclosed amounts. Pick a reason and add a note, or apply the change as a cure, for each fee.';

export const FEE_CHANGES_HEADING = 'Fee changes';

export const NOTE_LABEL = 'Notes';

export const NOTE_PLACEHOLDER = 'Explain why this fee changed';

export const NOTE_REQUIRED_MESSAGE = 'Notes are required with a reason';

export const APPLY_AS_CURE_LABEL = 'Apply as cure';

export const NEW_FEE_LABEL = 'New fee';

export const FEE_REASON_REQUIRED_MESSAGE = 'Choose a reason or apply as cure';

export const NO_LINKED_REASONS_MESSAGE =
  'No CIC reason is linked to this fee. Apply a cure to continue, or cancel this save.';

export const CURE_SELECTED_MESSAGE =
  'No CIC reason is linked to this fee. A cure will be applied when you save.';

export const APPLY_CURE_BUTTON_LABEL = 'Apply cure';

export const REMOVE_CURE_BUTTON_LABEL = 'Remove cure';

export const CANCEL_BUTTON_LABEL = 'Cancel';

export const CONFIRM_BUTTON_LABEL = 'Confirm & save';

export const DisclosureTypeChipTitle = {
  [CicDisclosureType.REVISED_LE]: 'Revised LE',
  [CicDisclosureType.REVISED_CD]: 'Revised CD',
};

export const EMPTY_ROW_VALUE = { cicReasonId: null, comment: '' };

export const EMPTY_FEE_ROW_VALUE = {
  cicReasonId: null,
  note: '',
  isCure: false,
};

export const NO_ITEMS = [];
